import { FC } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

type Props = {};

const TextFieldSkeleton: FC<Props> = props => {
  return (
    <Box>
      <Typography variant="caption">
        <Skeleton width={200} />
      </Typography>

      <Typography>
        <Skeleton />
      </Typography>
    </Box>
  );
};

export default TextFieldSkeleton;
